import dynamic from "next/dynamic";
import Link from "next/link";

/** One lazy chunk — uses `m` (minimal) not `motion` (drag/layout/projection). Requires `FramerLazyMotionRoot`. */
let framerMotionModulePromise;

function loadFramerMotionModule() {
  if (!framerMotionModulePromise) {
    framerMotionModulePromise = import("@/lib/framer-motion-lazy-api");
  }
  return framerMotionModulePromise;
}

const loadMotion = (tag) =>
  dynamic(
    () =>
      loadFramerMotionModule().then((mod) => mod.m[tag] ?? mod.m.div),
    { ssr: false }
  );

/** @see https://www.framer.com/motion/ — load after first paint via next/dynamic */
export const MotionDiv = loadMotion("div");
export const MotionH1 = loadMotion("h1");
export const MotionH2 = loadMotion("h2");
export const MotionH3 = loadMotion("h3");
export const MotionH4 = loadMotion("h4");
export const MotionH5 = loadMotion("h5");
export const MotionH6 = loadMotion("h6");
export const MotionP = loadMotion("p");
export const MotionSpan = loadMotion("span");
export const MotionButton = loadMotion("button");
export const MotionSection = loadMotion("section");

const motionByTag = {
  div: MotionDiv,
  h1: MotionH1,
  h2: MotionH2,
  h3: MotionH3,
  h4: MotionH4,
  h5: MotionH5,
  h6: MotionH6,
  p: MotionP,
  span: MotionSpan,
  button: MotionButton,
  section: MotionSection,
};

export function pickMotionByTag(tag, fallback = MotionH2) {
  if (typeof tag !== "string") return fallback;
  return motionByTag[tag.toLowerCase()] || fallback;
}

export const LazyAnimatePresence = dynamic(
  () => loadFramerMotionModule().then((mod) => mod.AnimatePresence),
  { ssr: false }
);

export const LazyMotionLink = dynamic(
  () => loadFramerMotionModule().then((mod) => mod.m.create(Link)),
  { ssr: false }
);
